import { Inject, Injectable } from '@angular/core';
import { Papa } from 'ngx-papaparse';
import { Observable, switchMap, map } from 'rxjs';
import { CRMImporterApiService, CSVHeaderMapping } from '@vendasta/crm';
import { CrmDependencies, CrmInjectionToken, ObjectType } from '@galaxy/crm/static';

interface CSVInfo {
  rows: string;
  isEstimate: boolean;
  firstRow: { [key: string]: string };
  rowMapping: CSVHeaderMapping[];
}

@Injectable()
export class CsvParserService {
  private namespace$ = this.config.namespace$;

  constructor(
    @Inject(CrmInjectionToken) private readonly config: CrmDependencies,
    private csvParser: Papa,
    private importer: CRMImporterApiService,
  ) {}

  parseCSV(crmObjectType: ObjectType, filename: string): Observable<CSVInfo> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.importer.getMultiFileUploadData({
          namespace,
          crmObjectType,
          filename: [filename],
        }),
      ),
      map((response) => response.files && response.files[0]),
      map((file) => {
        const headers = file?.headers || [];
        const firstRowEntries = headers.map(({ name, sampleData }) => [name, (sampleData && sampleData[0]) || '']);
        const firstRow = Object.fromEntries(firstRowEntries);
        return {
          rows: file.size.totalRows || '0',
          isEstimate: !!file?.size?.isEstimate,
          firstRow: firstRow,
          rowMapping: file?.mappingSuggestions,
        };
      }),
    );
  }
}
